<div class="CallContactDialog">
  <div class="CallContactDialog-info d-flex flex-row">
    <div class="CallContactDialog-info-item flex-grow-1">
      <div class="CallContactDialog-info-item-header d-flex align-items-center">
        <p>Contact</p>
      </div>
      <div class="CallContactDialog-info-item-item d-flex align-items-center">
        <p>{{ contact.contact_firstname }} {{ contact.contact_lastname }}</p>
      </div>
    </div>
    <div class="CallContactDialog-info-item flex-grow-1">
      <div class="CallContactDialog-info-item-header d-flex align-items-center">
        <p>Company</p>
      </div>
      <div class="CallContactDialog-info-item-item d-flex align-items-center">
        <p>{{ contact.contact_company }}</p>
      </div>
    </div>
    <div class="CallContactDialog-info-item flex-grow-1">
      <div class="CallContactDialog-info-item-header d-flex align-items-center">
        <p>Date</p>
      </div>
      <div class="CallContactDialog-info-item-item d-flex align-items-center">
        <p>test 2</p>
      </div>
    </div>
  </div>
  <div class="CallContactDialog-buttons d-flex flex-row py-5 px-3">
    <div class="flex-grow-1 text-center">
      <app-button
        [text]="'Left Message'"
        [size]="'small'"
        [color]="'green'"
        [Click]="leftMessageButton"></app-button>
    </div>
    <div class="flex-grow-1 text-center">
      <app-button-select
        [buttonProperties]="infoButtonProperties"
        [items]="infoButtonItems"></app-button-select>
    </div>
  </div>
  <p>
    Place a call to your contact now. There is a high probability that you will
    receive voicemail. Leave a simple message like, "I have been reaching out to
    you regarding "x" via email and just wanted to leave you a quick message
    too. I will send you an email in follow up to this message incase that is a
    more convenient way to communicate. Thank you!"
  </p>
</div>
